export type ReferenceUrlKind = 'empty' | 'external' | 'inline' | 'invalid'

function normalizeCandidate(value: string | null | undefined) {
  return String(value || '').trim()
}

export function normalizeReferenceUrl(value: string | null | undefined) {
  return normalizeCandidate(value)
}

export function getReferenceUrlKind(value: string | null | undefined): ReferenceUrlKind {
  const normalized = normalizeCandidate(value)
  if (!normalized) {
    return 'empty'
  }

  if (normalized.startsWith('data:') || normalized.startsWith('blob:')) {
    return 'inline'
  }

  try {
    const parsed = new URL(normalized)
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? 'external' : 'invalid'
  } catch {
    return 'invalid'
  }
}

export function isReferenceUrlEffective(value: string | null | undefined) {
  const kind = getReferenceUrlKind(value)
  return kind === 'external' || kind === 'inline'
}

export function canOpenReferenceUrl(value: string | null | undefined) {
  return getReferenceUrlKind(value) === 'external'
}

export function summarizeReferenceUrl(value: string | null | undefined) {
  const normalized = normalizeCandidate(value)
  if (!normalized) {
    return ''
  }

  if (normalized.startsWith('data:')) {
    return '本地预览数据'
  }
  if (normalized.startsWith('blob:')) {
    return '本地文件预览'
  }

  try {
    const parsed = new URL(normalized)
    const pathname = parsed.pathname.length > 28 ? `...${parsed.pathname.slice(-28)}` : parsed.pathname
    return `${parsed.hostname}${pathname || ''}`
  } catch {
    return normalized.length > 40 ? `${normalized.slice(0, 40)}...` : normalized
  }
}

export function openReferenceUrl(value: string | null | undefined) {
  const normalized = normalizeCandidate(value)
  if (!canOpenReferenceUrl(normalized)) {
    return false
  }

  window.open(normalized, '_blank', 'noopener,noreferrer')
  return true
}

export async function copyReferenceUrl(value: string | null | undefined) {
  const normalized = normalizeCandidate(value)
  if (!normalized) {
    return false
  }

  await navigator.clipboard.writeText(normalized)
  return true
}